// Example: DashboardPage.js
import React from 'react';
import Dashboard from '../features/dashboard/pages/Dashboard';

const DashboardPage = () => (
<Dashboard />
);

export default DashboardPage;